/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function LogoutComponent({ backgroundColorClass,
  backgroundColor,
  textColor,
  fontFamily,
 }) {
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("accesstoken");
    window.location.reload();
  };

  const dynamicStyle = {
    ...(backgroundColor && { backgroundColor }),
    ...(textColor && { color: textColor }),
    ...(fontFamily && { fontFamily }),
  };
  return (
    <div className={`logout ${backgroundColorClass}`} style={dynamicStyle}>
      Need to switch accounts?{" "}
      <strong>
        <a onClick={(e) => handleLogout(e)}>Logout here</a>
      </strong>
    </div>
  );
}
